import {RemoteGetUpdateIndicator} from 'data/usecases/private/profile/remote-get-update-indicator';
import {GetBeneficiaryAddressValidationV4} from 'domain/usecases/private/profile/get-update-indicator';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetUpdateIndicator = (): GetBeneficiaryAddressValidationV4 =>
	new RemoteGetUpdateIndicator(
		makeBFFApiUrl(ProfileChangeDataEndpoints.addressUpdateIndicatorV4),
		makeAuthorizeHttpClientDecorator(),
	);
